import { Link } from 'react-router-dom'
import React, {useContext, useEffect, useRef, useState} from 'react'
import MUIDataTable from 'mui-datatables'
import api from '../../services/api'
import { DataTableOptions } from '../../components/dataTableOptions'
import PrintingComponent from "../../components/printingComponent";
import CommitmentParticipation from "./CommitmentParticipation";
import DeclarationAffiliation from "./DeclarationAffiliation";
import {MainContext} from "../../context/MainContext";
import AnnuityReport from "../Annuities/report";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import AthetesReport from "./report";
import PresenceReportComponent from "./Presence/report";

export default function ListingAthletes() {
  const {setPageTitle, setLoading} = useContext(MainContext)
  const [athletes, setAthletes] = useState<any>([])
  const [impressao, setImpressao] = useState<any>({})

  const [showButton, setShowButton] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === 'k') {
        e.preventDefault();

        setShowButton(true);

        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
          setShowButton(false);
        }, 5000);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const getAthletes = async () => {
    await api.get('/api/athletes').then((response) => {
      const data = response.data
      setAthletes(data)
    })
  }

  function registerAttendance(hab:any) {
    Swal.fire({
      title: 'Tem certeza que deseja realizar essa ação?',
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#198754",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim",
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (result.isConfirmed) {
        try{
          setLoading(true)
          const payload = {
            "athlete_id": hab,
            "attendance_date": dayjs().format('YYYY-MM-DD'),
            "status": "present",
            "capture_quality": "high",
            "capture_timestamp": dayjs().format('YYYY-MM-DD HH:mm:ss'),
            "unique_capture_id": `capture${dayjs().valueOf()}`
          }
          api['post'](`/api/app/registerAttendance`, payload)
              .then((result) => {
                setLoading(false)
                Swal.fire({
                  title: 'Sucesso!',
                  text: result.data.message,
                  icon: 'success',
                }).then(() => setLoading(false));
              })
              .catch(erro => {
                setLoading(false)
                Swal.fire({
                  title: 'Erro!',
                  text: erro.response.data.message,
                  icon: 'error',
                });
              });
        }catch (err: any) {
          setLoading(false)
          Swal.fire({
            title: 'Erro!',
            text: err,
            icon: 'error',
          })
        }
      }
    });
  }

  const childToParent = (childdata:any) => {
    setImpressao({imprimir:false, athlete:null, tipo:null})
  }

  useEffect(() => {
    setPageTitle("Sócios")
    setLoading(true)

    const fetchData = async () => {
      await getAthletes()
    };

    fetchData().then(setLoading(false))
  }, [])

  const columns: any = [
    {
      name: 'member_number', label: 'N. sócio', options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'full_name', label: 'Nome', options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'birth_date_formated', label: 'Data nasc', options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'phone', label: 'TELEFONE', options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: '', label: '', options: {
        filter: false,
        false: true,
        customBodyRenderLite: (index: string | number) => {return (
            <>
              {showButton &&
                <button id="btnPrinter" type="button" className="btn btn-sm btn-secondary me-2"
                        onClick={() => registerAttendance(athletes[index]?.id)}>
                  <i className="bi bi-fingerprint"></i></button>
              }

              <Link className='btn btn-sm btn-success me-2' to={`/annuity/${athletes[index]?.id}`} title="Anuidade">
                <i className="bi bi-cash-coin" aria-hidden="true"></i>
              </Link>

              <Link className='btn btn-sm btn-warning me-2' to={`/members/update/${athletes[index]?.id}`} title="Editar">
                <i className="bi bi-pencil" aria-hidden="true"></i>
              </Link>

              <button id="btnPrinter" type="button" className="btn btn-sm btn-primary dropdown-toggle"
                      data-bs-toggle="dropdown" aria-expanded="false"><i className="bi bi-printer"></i></button>
              <ul className="dropdown-menu" aria-labelledby="btnPrinter">
                <li><a className="dropdown-item" href="#" onClick={() => setImpressao({
                  imprimir: true,
                  athlete: athletes[index]?.id,
                  tipo: 'DeclarationAffiliation'
                })}>Declaração De Filiação</a></li>
                <li><a className="dropdown-item" href="#" onClick={() => setImpressao({
                  imprimir: true,
                  athlete: athletes[index]?.id,
                  tipo: 'CommitmentParticipation'
                })}>Compromisso Em Participações</a></li>
              </ul>
            </>
        )
        },
      },
    },
  ]

  const options: any = DataTableOptions

  return (
      <>
        <div className='mb-4'>
            <div className="col-lg-12">
              <div className="card h-100">
                <div className="card-body mt-3">
                  <ul className="nav nav-pills mb-3" id="pillTabs" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button className="nav-link active" id="pill-listing-tab" data-bs-toggle="pill"
                              data-bs-target="#pill-listing" type="button" role="tab" aria-selected="true"><i className="bi bi-plus-circle me-1"></i>Cadastro
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" id="pill-presence-tab" data-bs-toggle="pill"
                              data-bs-target="#pill-presence" type="button" role="tab" aria-selected="false"
                              tabIndex={-1}><i className="bi bi-fingerprint me-1"></i>Relatório de presenças
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" id="pill-members-tab" data-bs-toggle="pill"
                              data-bs-target="#pill-members" type="button" role="tab" aria-selected="false"
                              tabIndex={-1}><i className="bi bi-people-fill me-1"></i>Relatório de Sócios
                      </button>
                    </li>
                  </ul>
                  <div className="tab-content p-3 bg-light rounded" id="pillTabsContent">
                    <div className="tab-pane fade show active" id="pill-listing" role="tabpanel"
                         aria-labelledby="pill-listing-tab">
                      <div className="row g-3 mb-0 ">

                      <div className="col-lg-3">
                        <Link className='btn btn-success d-md-block' to='/members/create'><i
                            className="bi bi-plus-circle">&nbsp;</i> Cadastrar Sócio</Link>
                      </div>
                      <div className="col-lg-5">
                        <AnnuityReport/>
                      </div>

                      <MUIDataTable
                          title={''}
                          data={athletes}
                          columns={columns}
                          options={options}
                      />
                      </div>
                    </div>
                    <div className="tab-pane fade" id="pill-presence" role="tabpanel" aria-labelledby="pill-presence-tab">
                      <PresenceReportComponent/>
                    </div>
                    <div className="tab-pane fade" id="pill-members" role="tabpanel" aria-labelledby="pill-members-tab">
                      <AthetesReport/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>

        {impressao.imprimir &&
            <PrintingComponent componentToPrint={impressao.tipo === "CommitmentParticipation" ?
                <CommitmentParticipation athleteId={impressao.athlete}/> :
                <DeclarationAffiliation athleteId={impressao.athlete}/>} textButon={""} childToParent={childToParent}/>
        }
      </>
  )
}
